let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eemhl")).then(() => parcelRequire('2ZKr3'));